module.exports = __webpack_public_path__ + "images/bb7f9dc71047cbd2bc3e5f5686ae6dec-library_post.png";